import type { AnalyticsEvent } from "./events";
import { analyticsEnabled, loadProviders } from "./loader";
import { PROVIDERS } from "./providers";

/** Потолок буфера: при заблокированных скриптах он иначе рос бы вечно. */
const MAX_BUFFERED = 50;

let started = false;
let ready = false;
const buffered: AnalyticsEvent[] = [];

/** Ставит загрузку SDK в очередь на idle. Вызывается один раз за жизнь
 *  страницы из useRouteAnalytics; повторные вызовы безвредны. */
export function startAnalytics(): void {
  if (started || !analyticsEnabled()) return;
  started = true;
  loadProviders(() => {
    ready = true;
    const pending = buffered.splice(0, buffered.length);
    pending.forEach(deliver);
  });
}

/** Единственный способ отправить событие. Пока SDK не загрузились, событие
 *  копится в буфере и уходит после — так первый page_view не теряется. */
export function track(event: AnalyticsEvent): void {
  if (!analyticsEnabled()) return;
  if (!ready) {
    if (buffered.length < MAX_BUFFERED) buffered.push(event);
    return;
  }
  deliver(event);
}

function deliver(event: AnalyticsEvent): void {
  PROVIDERS.forEach((p) => {
    try {
      p.send?.(event);
    } catch {
      // Отсутствующий SDK — нормальное состояние, а не ошибка: у части
      // посетителей его вырезает блокировщик рекламы.
    }
  });
}
